import { ADMIN_APP_TOKEN_ID } from "@chatsystem/common/config";

/**
 * React identity for the fixed Playin marketing widget.
 *
 * Keeping this separate from acquisition-demo identities forces the canonical
 * client to discard every previous conversation and settings context when a
 * visitor moves between the two product surfaces.
 */
export const MARKETING_WIDGET_RUNTIME_KEY =
  `standard-widget:${ADMIN_APP_TOKEN_ID}` as const;

/** Returns the isolated React identity of one public acquisition demo. */
export const acquisitionDemoWidgetRuntimeKey = (publicId: string): string =>
  `acquisition-demo:${publicId}`;

